<div fxLayout="column" class="patient-selection" fxFlex="100">

  <!-- ################################################## -->
  <!-- Coverage Summary Verbiage On Top Of The Product Package Eligible Items -->
  <!-- ################################################## -->
  <div fxLayout="row">
    <div class="nested-column-12">
      <h1 id="coverage-summary-title" class="eclaim-header-text margin-top-10 margin-bottom-15">COVERAGE SUMMARY</h1>
      <!-- Date of Service Instructions -->
      <p id="coverage-summary-dos-instructions" class="eclaim-body-text margin-bottom-20">To view eligibility for past
        Date of Service, enter date and click on the Update button.</p>
      <!-- Date of Service Form -->
      <form fxLayout="column" class="eclaim-body-text" novalidate [formGroup]="coverageSummaryFormGroup"
            (ngSubmit)="onCoverageSummaryFormSubmit()">
        <p class="eclaim-body-text margin-bottom-15" id="coverage-summary-for-date-of-service-text"><span
          class="required-label-asterisk">* </span>Date of Service</p>
        <div fxLayout="row">
          <app-date-picker class="required-mat-form-field" id="coverage-summary-date-picker"
                           [datePickerConfiguration]="datePickerConfiguration"></app-date-picker>
          <button mat-stroked-button color="primary" fxFlexOffset="30px" class="claim-progress-action-button"
                  [disabled]="coverageSummaryFormGroup.controls.dateOfService.invalid"
                  (click)="updateEligibilityUsingAsOfDateFromDateOfService()" id="coverage-summary-date-update-button">
            <span>Update</span>
          </button>
        </div>
      </form>
      <!-- Client Messages - Only show if there are client messages in the eligibility data -->
      <div fxLayout="row" class="margin-top-20" *ngIf="hasClientMessages()">
        <div class="container-light-blue">
          <!-- Client Messages -->
          <div fxLayout="row" class="clientMessageList" *ngFor="let clientMessage of clientMessages">
            <mat-icon fxFlex="30px" svgIcon="eclaim-icons:infoCircle"></mat-icon>
            <strong class="client-message-text">{{clientMessage}}</strong>
          </div>
        </div>
      </div>
      <!-- Patient Name -->
      <p id="coverage-summary-patient-name-label" class="eclaim-body-text-bold margin-top-20 margin-bottom-15">Patient
        Name:<span class="margin-left-3">{{getFullName()}}</span></p>
      <p id="coverage-summary-print-vsp-plan-summary-label" class="eclaim-body-text margin-bottom-15">Print <label
        class="action-link" (click)="viewPlanSummary()" id="coverage-summary-vsp-plan-summary-link">VSP Plan
        Summary</label> to give to your patient</p>
      <!-- Instructions -->
      <p *ngIf="!loadingEligibility" id="coverage-summary-select-available-services-text"
         class="eclaim-body-text margin-bottom-20">Select available services to be included in the Authorization.</p>
    </div>
  </div>

  <!-- ################################################## -->
  <!-- Coverage Summary Product Package Eligible Items -->
  <!-- ################################################## -->
  <div fxLayout="column" *ngIf="!loadingEligibility">
    <div fxLayout="row" *ngFor="let productPackage of eligibilityProductPackages; index as baseId">
      <mat-card class="margin-bottom-30 mat-card nested-column-12"
                id="coverage-summary-product-package-panel-{{productPackage.name}}"
                *ngIf="!productPackage.hasOnlyNonAuthorizableItemsAndNoDescription">
        <mat-card-header>
          <mat-card-title>
            <h1 class="float-left"
                id="coverage-summary-product-package-title-index-{{baseId}}">
              {{ productPackage.businessName }}
            </h1>
          </mat-card-title>
        </mat-card-header>

        <div [class.available-benefits-container]="shouldGrayOutAvailableServices(productPackage)">

          <!-- ################################################## -->
          <!-- First Row In The Package Eligible Items -->
          <!-- ################################################## -->
          <div fxLayout="row" *ngIf="!productPackage.hasOnlyNonAuthorizableItems"
               class="margin-top-18 margin-bottom-18 align-label-text-in-center" id="{{baseId}}-table">
            <!-- Empty Label for First Column -->
            <label class="custom-nested-column-1_6"></label>
            <!-- All Available Services -->
            <label fxLayoutAlign="center center" id="coverage-summary-all-available-services-label"
                   class="custom-nested-column-1_8 eclaim-body-text-bold align-label-text-in-center">All Available
              Services</label>
            <!-- Dynamic Service Headers -->
            <div fxLayoutAlign="center center"
                 class="custom-nested-column-1_4 eclaim-body-text-bold align-label-text-in-center"
                 id="{{baseId}}-service-header" *ngFor="let eligibleItem of eligibilityProductPackagesOnlyAuthorizedItems(productPackage.businessName)">
              <label *ngIf="eligibleItem.authorizable">{{ eligibleItem.description }}</label>
            </div>
          </div>

          <!-- ################################################## -->
          <!-- Row Divider -->
          <!-- ################################################## -->
          <div fxLayout="row">
            <mat-divider></mat-divider>
          </div>

          <!-- ################################################## -->
          <!-- Second Row In The Package Eligible Items -->
          <!-- ################################################## -->
          <div fxLayout="row" class="margin-top-18 margin-bottom-18">
            <!-- "Availability" -->
            <label fxLayoutAlign="start center" id="coverage-summary-availability"
                   class="custom-nested-column-1_6 eclaim-body-text-bold">Availability</label>
            <!--Empty Label Under the All Available Services-->
            <label class="custom-nested-column-1_8"></label>
            <!-- Status Description Dynamic Values -->
            <div fxLayoutAlign="center center"
                 class="custom-nested-column-1_4 eclaim-body-text align-label-text-in-center"
                 *ngFor="let eligibleItem of eligibilityProductPackagesOnlyAuthorizedItems(productPackage.businessName); index as i"
                 id="{{baseId}}-availability-{{i}}">
              <label *ngIf="eligibleItem.authorizable">{{ eligibleItem.statusDescription }}</label>
            </div>
          </div>

          <!-- ################################################## -->
          <!-- Row Divider -->
          <!-- ################################################## -->
          <div fxLayout="row">
            <mat-divider></mat-divider>
          </div>

          <!-- ################################################## -->
          <!-- Third Row In The Package Eligible Items -->
          <!-- ################################################## -->
          <div fxLayout="row">
            <!-- Authorize Benefit row -->
            <label fxLayoutAlign="start center" id="coverage-summary-authorize-benefit-label"
                   class="custom-nested-column-1_6 margin-top-18 margin-bottom-18 eclaim-body-text-bold">Authorize
              Benefit</label>
            <!-- All Available Services Checkbox -->
            <!-- This Div Was Needed to Address ECR-10776 Issue-->
            <div fxLayoutAlign="center center" class="custom-nested-column-1_8 margin-top-18 margin-bottom-18">
              <mat-checkbox id="{{baseId}}-all-available-services-checkbox"
                            [checked]="productPackage.allAvailableServices"
                            [disabled]="shouldDisableAllAvailableServicesCheckbox(productPackage)"
                            (change)="toggleAuthorizeBenefitCheckboxForAllProductPackageEligibleItems(productPackage)"
                            (keyup.enter)="toggleAuthorizeBenefitCheckboxForAllProductPackageEligibleItems(productPackage)">
              </mat-checkbox>
            </div>
            <!-- Dynamic Service Checkboxes -->
            <div fxLayoutAlign="center center" class="custom-nested-column-1_4 margin-top-18 margin-bottom-18"
                 *ngFor="let eligibleItem of eligibilityProductPackagesOnlyAuthorizedItems(productPackage.businessName); index as i">
              <mat-checkbox *ngIf="eligibleItem.authorizable"
                            id="{{baseId}}-service-checkbox-{{i}}"
                            [checked]="eligibleItem.authorizable && eligibleItem.isSelected"
                            [disabled]="shouldDisableAvailableServiceCheckbox(productPackage, eligibleItem)"
                            (change)="toggleAuthorizedBenefitCheckboxForSingleEligibleItem(eligibleItem, productPackage)"
                            (keyup.enter)="toggleAuthorizedBenefitCheckboxForSingleEligibleItem(eligibleItem, productPackage)">
              </mat-checkbox>

            </div>
          </div>

          <!-- ################################################## -->
          <!-- Row Divider -->
          <!-- ################################################## -->
          <div fxLayout="row">
            <mat-divider></mat-divider>
          </div>

        </div>

        <!-- ################################################## -->
        <!-- Conditional Fourth Row In The Package Eligible Items -->
        <!-- ################################################## -->
        <div *ngIf="productPackage.hasOnlyNonAuthorizableItems" class="non-authroizable-only-description">
          {{productPackage.nonAuthPackageLongDescription}}
        </div>

        <!-- ################################################## -->
        <!-- Fifth Row In The Package Eligible Items -->
        <!-- ################################################## -->

        <!-- Medicaid Repair & Replace benefit if applicable.  -->
        <div *ngIf="productPackage.isMrrFlow" class="mrr-available-benefits-container">
          <!-- MRR Banner-->
          <mat-card *ngIf="!showMrrAvailableBenefits(productPackage)" class="banner-card margin-top-20 margin-left-15">
            <div fxLayout="row" fxLayoutAlign="start center" style="height:50px">
            <span class="banner-card-icon-span">
              <mat-icon class="banner-card-icon mrr-triangle" color="primary" svgIcon="eclaim-icons:warningTriangle"></mat-icon>
            </span>
              <span class="banner-card-text">
              <mat-label>
                  Medicaid Repair &amp; Replace benefit available.
                <label id="coverage-summary-show-benefits-available-mrr" class="action-link nested-column-6"
                       (click)="toggleShowMrrAvailableBenefits(productPackage)">Click here to use benefit.</label>
              </mat-label>
            </span>
            </div>
          </mat-card>

          <div fxLayout="column" *ngIf="showMrrAvailableBenefits(productPackage)">
            <!-- Medicaid Verbiage-->
            <div fxLayout="row" fxLayoutAlign="start start" class="margin-top-20 margin-left-15">
              <mat-icon class="banner-card-icon" color="primary" svgIcon="eclaim-icons:warningTriangle"></mat-icon>
              <label>
                By submitting this request, you attest the patient meets the state’s guidelines including age criteria
                for repair/replacement eligibility and one of the following reasons:
              </label>
            </div>

            <!-- Medicaid DropDown-->
            <div fxLayout="row" fxLayoutAlign="start center" id="dropdown-container-mrr"
                 class="nested-column-7 margin-top-15 margin-bottom-30">
              <select matSelect [(ngModel)]="productPackage.mrrDropdownSelection" class="custom-select MRR-dropdown" id="dropdown-mrr">
                <option value="" selected disabled hidden>Please select</option>
                <option *ngFor="let item of MRRDropdownItems" id="dropdown-item-{{item.value}}-mrr" [value]="item.value"
                        class="MRR-dropdown-option">
                  {{ item.value }}
                </option>
              </select>
            </div>

            <!-- MRR Available Services table-->
            <div fxLayout="column">
              <!-- row 1 -->
              <div fxLayout="row" *ngIf="!productPackage.hasOnlyNonAuthorizableItems"
                   class="margin-top-18 margin-bottom-18 align-label-text-in-center" id="{{baseId}}-table-mrr">
                <!-- Empty Label for First Column -->
                <label class="custom-nested-column-1_6"></label>
                <!-- All Available Services -->
                <label fxLayoutAlign="center center" id="coverage-summary-all-available-services-label-mrr"
                       class="custom-nested-column-1_8 eclaim-body-text-bold align-label-text-in-center">
                  All Available Services
                </label>
                <!-- Dynamic Service Headers -->
                <div fxLayoutAlign="center center"
                     class="custom-nested-column-1_4 eclaim-body-text-bold align-label-text-in-center"
                     id="{{baseId}}-service-header-mrr" *ngFor="let eligibleItem of productPackage.mrrEligibleItems">
                  <label *ngIf="eligibleItem.authorizable">{{ eligibleItem.description }}</label>
                </div>
              </div>

              <!-- ################################################## -->
              <!-- Row Divider -->
              <!-- ################################################## -->
              <div fxLayout="row">
                <mat-divider></mat-divider>
              </div>

              <!-- row 2 -->
              <div fxLayout="row" class="margin-top-18 margin-bottom-18">
                <!-- "Availability" -->
                <label fxLayoutAlign="start center" id="coverage-summary-availability-mrr"
                       class="custom-nested-column-1_6 eclaim-body-text-bold">Availability</label>
                <!--Empty Label Under the All Available Services-->
                <label class="custom-nested-column-1_8"></label>
                <!-- Status Description Dynamic Values -->
                <div fxLayoutAlign="center center"
                     class="custom-nested-column-1_4 eclaim-body-text align-label-text-in-center"
                     *ngFor="let eligibleItem of productPackage.mrrEligibleItems; index as i" id="{{baseId}}-availability-{{i}}-mrr">
                  <label *ngIf="eligibleItem.authorizable">{{eligibleItem.statusDescription}}</label>
                </div>
              </div>

              <!-- ################################################## -->
              <!-- Row Divider -->
              <!-- ################################################## -->
              <div fxLayout="row">
                <mat-divider></mat-divider>
              </div>

              <!-- row 3 -->
              <div fxLayout="row">
                <!-- Authorize Benefit row -->
                <label fxLayoutAlign="start center" id="mrr-coverage-summary-authorize-benefit-label"
                       class="custom-nested-column-1_6 margin-top-18 margin-bottom-18 eclaim-body-text-bold">
                  Authorize Benefit
                </label>
                <!-- All Available Services Checkbox -->
                <div fxLayoutAlign="center center" class="custom-nested-column-1_8 margin-top-18 margin-bottom-18">
                  <mat-checkbox id="{{baseId}}-all-available-services-checkbox-mrr"
                                [checked]="productPackage.allAvailableMrrServices"
                                [disabled]="!hasAnyAvailableMrrServices(productPackage)"
                                (change)="toggleAuthorizeBenefitCheckboxForAllProductPackageEligibleItemsMrr(productPackage)"
                                (keyup.enter)="toggleAuthorizeBenefitCheckboxForAllProductPackageEligibleItemsMrr(productPackage)">
                  </mat-checkbox>
                </div>
                <!-- Dynamic Service Checkboxes -->
                <div fxLayoutAlign="center center" class="custom-nested-column-1_4 margin-top-18 margin-bottom-18"
                     *ngFor="let eligibleItem of productPackage.mrrEligibleItems; index as i">
                  <mat-checkbox *ngIf="eligibleItem.authorizable"
                                id="{{baseId}}-service-checkbox-{{i}}-mrr"
                                [checked]="eligibleItem.authorizable && eligibleItem.isSelected"
                                [disabled]="!isAvailableToAuthorize(eligibleItem)"
                                (change)="toggleAuthorizedBenefitCheckboxForSingleEligibleItemMrr(eligibleItem, productPackage)"
                                (keyup.enter)="toggleAuthorizedBenefitCheckboxForSingleEligibleItemMrr(eligibleItem, productPackage)">
                  </mat-checkbox>
                </div>
              </div>
            </div>


          </div>
        </div>

        <!-- Contact Lens Remaining Allowance (CLRA) benefit if applicable.  -->
        <div *ngIf="productPackage.isClraFlow" id="clra-available-benefits-container" [class.available-benefits-container]="isAnyEligibleItemSelected(productPackage.eligibleItems)">

          <div fxLayout="row" *ngIf="!productPackage.hasOnlyNonAuthorizableItems"
               class="margin-top-18 margin-bottom-18 align-label-text-in-center" id="{{baseId}}-table-clra">
            <!-- Empty Label for First Column -->
            <label class="custom-nested-column-1_6"></label>
            <!-- Remaining Contact Lens -->
            <label fxLayoutAlign="center center" id="coverage-summary-remaining-contact-lens-label"
                   class="custom-nested-column-1_9 eclaim-body-text-bold align-label-text-in-center">Remaining Contact
              Lens
            </label>
          </div>

          <!-- Row Divider -->
          <div fxLayout="row">
            <mat-divider></mat-divider>
          </div>

          <div fxLayout="row">
            <!-- Availability -->
            <label fxLayoutAlign="start center" id="coverage-summary-clra-availability"
                   class="custom-nested-column-1_6 eclaim-body-text-bold">Availability</label>
            <!-- Available CLRA benefit message -->
            <div fxLayoutAlign="center center" class="custom-nested-column-1_9 margin-top-18 margin-bottom-18">
              <label class="clra-message">
                <label class="clra-message-amount-label" id="clra-amount-label">{{productPackage.clraAmount}}</label> Available
              </label>
            </div>
          </div>

          <!-- Row Divider -->
          <div fxLayout="row">
            <mat-divider></mat-divider>
          </div>

          <div fxLayout="row">
            <!-- Authorize CLRA Benefit row -->
            <label fxLayoutAlign="start center" id="coverage-summary-clra-authorize-benefit-label"
                   class="custom-nested-column-1_6 margin-top-18 margin-bottom-18 eclaim-body-text-bold">Authorize
              Benefit</label>
            <!-- Remaining Contact Lens Authorize Benefit Checkbox -->
            <div fxLayoutAlign="center center" class="custom-nested-column-1_8 margin-top-18 margin-bottom-18">
              <mat-checkbox id="clra-service-checkbox"
                            [checked]="isClraCheckboxChecked(productPackage)"
                            [disabled]="isAnyEligibleItemSelected(productPackage.eligibleItems)"
                            (change)="toggleAuthorizeBenefitCheckboxForCLRA(productPackage)"
                            (keyup.enter)="toggleAuthorizeBenefitCheckboxForCLRA(productPackage)">
              </mat-checkbox>
            </div>
          </div>

          <!-- Row Divider -->
          <div fxLayout="row">
            <mat-divider></mat-divider>
          </div>

        </div>


        <!-- Applicable Buttons   -->
        <div fxLayout="row" [fxLayoutAlign]="(shouldDisplayCancelButton(productPackage) ? 'space-between' : 'end') + ' ' + 'center'"
             *ngIf="!productPackage.hasOnlyNonAuthorizableItems"
             id="issue-authorization-button-and-package-name" class="coverage-summary-package-bottom-bar">

          <!-- Cancel Button for MRR -->
          <button *ngIf="showMrrAvailableBenefits(productPackage) && productPackage.isMrrFlow"
                  mat-flat-button class="nested-column-2 mat-flat-button mat-primary"
                  id="cancel-button-mrr"
                  (click)="toggleShowMrrAvailableBenefits(productPackage)">Cancel
          </button>

          <!-- Cancel Button for CLRA -->
          <button *ngIf="productPackage.isClraFlow"
                  mat-flat-button class="nested-column-2 mat-flat-button mat-primary"
                  id="cancel-button-clra"
                  [disabled]="disableClraCancelButton(productPackage)"
                  (click)="onClickCancelClra(productPackage)">Cancel
          </button>

          <!-- Issue Authorization Button-->
          <button mat-flat-button class="nested-column-2 mat-flat-button mat-primary"
                  [disabled]="!hasAnyEligibleItemsSelected(productPackage)"
                  id="{{baseId}}-issue-authorization-button"
                  (click)="issueAuthorization(productPackage)">Issue Authorization
          </button>
        </div>
      </mat-card>

    </div>
  </div>

</div>
